import Locales from "./Locale/index.js";
var EGeneralTimeZones = /* @__PURE__ */ ((EGeneralTimeZones2) => {
  EGeneralTimeZones2["BEIJING"] = "+0800";
  EGeneralTimeZones2["GMT"] = "+0000";
  EGeneralTimeZones2["PDT"] = "-0700";
  EGeneralTimeZones2["PST"] = "-0800";
  EGeneralTimeZones2["EDT"] = "-0400";
  EGeneralTimeZones2["EST"] = "-0500";
  return EGeneralTimeZones2;
})(EGeneralTimeZones || {});
var EWeekday = /* @__PURE__ */ ((EWeekday2) => {
  EWeekday2[EWeekday2["SUNDAY"] = 0] = "SUNDAY";
  EWeekday2[EWeekday2["MONDAY"] = 1] = "MONDAY";
  EWeekday2[EWeekday2["TUESDAY"] = 2] = "TUESDAY";
  EWeekday2[EWeekday2["WEDNESDAY"] = 3] = "WEDNESDAY";
  EWeekday2[EWeekday2["THURSDAY"] = 4] = "THURSDAY";
  EWeekday2[EWeekday2["FRIDAY"] = 5] = "FRIDAY";
  EWeekday2[EWeekday2["SATURDAY"] = 6] = "SATURDAY";
  return EWeekday2;
})(EWeekday || {});
var EMonth = /* @__PURE__ */ ((EMonth2) => {
  EMonth2[EMonth2["JANUARY"] = 0] = "JANUARY";
  EMonth2[EMonth2["FEBRUARY"] = 1] = "FEBRUARY";
  EMonth2[EMonth2["MARCH"] = 2] = "MARCH";
  EMonth2[EMonth2["APRIL"] = 3] = "APRIL";
  EMonth2[EMonth2["MAY"] = 4] = "MAY";
  EMonth2[EMonth2["JUNE"] = 5] = "JUNE";
  EMonth2[EMonth2["JULY"] = 6] = "JULY";
  EMonth2[EMonth2["AUGUST"] = 7] = "AUGUST";
  EMonth2[EMonth2["SEPTEMBER"] = 8] = "SEPTEMBER";
  EMonth2[EMonth2["OCTOBER"] = 9] = "OCTOBER";
  EMonth2[EMonth2["NOVEMBER"] = 10] = "NOVEMBER";
  EMonth2[EMonth2["DECEMBER"] = 11] = "DECEMBER";
  return EMonth2;
})(EMonth || {});
const MS_PER_SECOND = 1e3;
const SECONDS_PER_MINUTE = 60;
const MS_PER_MINUTE = MS_PER_SECOND * SECONDS_PER_MINUTE;
const MINUTES_PER_HOUR = 60;
const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * MINUTES_PER_HOUR;
const MS_PER_HOUR = MS_PER_SECOND * SECONDS_PER_HOUR;
const HOURS_PER_DAY = 24;
const MINUTES_PER_DAY = MINUTES_PER_HOUR * HOURS_PER_DAY;
const SECONDS_PER_DAY = SECONDS_PER_HOUR * HOURS_PER_DAY;
const MS_PER_DAY = MS_PER_SECOND * SECONDS_PER_DAY;
const DAYS_PER_WEEK = 7;
const HOURS_PER_WEEK = HOURS_PER_DAY * DAYS_PER_WEEK;
const MINUTES_PER_WEEK = MINUTES_PER_DAY * DAYS_PER_WEEK;
const SECONDS_PER_WEEK = SECONDS_PER_DAY * DAYS_PER_WEEK;
const MS_PER_WEEK = MS_PER_SECOND * SECONDS_PER_WEEK;
const MONTH_PER_YEAR = 12;
function isLeapYear(year) {
  return year % 400 === 0 || year % 100 !== 0 && year % 4 === 0;
}
function getDaysInMonth(year, month) {
  switch (month) {
    case 0:
    case 2:
    case 4:
    case 6:
    case 7:
    case 9:
    case 11:
      return 31;
    case 3:
    case 5:
    case 8:
    case 10:
      return 30;
    case 1:
      return isLeapYear(year) ? 29 : 28;
    default:
      throw new RangeError("Month must be 0 ~ 11.");
  }
}
function getDaysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function pad(n, length = 2) {
  const isLtZero = n < 0;
  if (isLtZero) {
    n = -n;
  }
  return (isLtZero ? "-" : "") + n.toString().padStart(length, "0");
}
function tzFromJS(tz) {
  const sign = tz <= 0 ? "+" : "-";
  tz = Math.abs(tz);
  const hour = pad(Math.floor(tz / 60));
  const minute = pad(Math.abs(tz) % 60);
  return `${sign}${hour}${minute}`;
}
function tzToJS(tz) {
  if (tz[0] === "+") {
    return -(parseInt(tz.slice(1, 3)) * 60 + parseInt(tz.slice(3, 5)));
  }
  return parseInt(tz.slice(1, 3)) * 60 + parseInt(tz.slice(3, 5));
}
const ENV_TIMEZONE = tzFromJS((/* @__PURE__ */ new Date()).getTimezoneOffset());
function parseLocalTime(ts = Date.now(), tz = ENV_TIMEZONE) {
  const d = new Date(ts - tzToJS(tz) * MS_PER_MINUTE);
  return {
    yr: d.getUTCFullYear(),
    mo: d.getUTCMonth(),
    day: d.getUTCDate(),
    hr: d.getUTCHours(),
    min: d.getUTCMinutes(),
    sec: d.getUTCSeconds(),
    ms: d.getUTCMilliseconds(),
    wd: d.getUTCDay(),
    timezone: d.getTimezoneOffset()
  };
}
function buildISODateString(dt, tz = ENV_TIMEZONE) {
  return `${dt.yr}-${pad((dt.mo ?? 0) + 1)}-${pad(dt.day ?? 1)}T${pad(dt.hr ?? 0)}:${pad(dt.min ?? 0)}:${pad(dt.sec ?? 0)}.${pad(dt.ms ?? 0, 3)}${tz}`;
}
function buildDateTimeString(dt) {
  return `${dt.yr}-${pad((dt.mo ?? 0) + 1)}-${pad(dt.day ?? 1)} ${pad(dt.hr ?? 0)}:${pad(dt.min ?? 0)}:${pad(dt.sec ?? 0)}`;
}
function timeToISODateString(ts = Date.now(), tz = ENV_TIMEZONE) {
  return buildISODateString(parseLocalTime(ts, tz), tz);
}
function timeToDateTimeString(ts = Date.now(), tz = ENV_TIMEZONE) {
  return buildDateTimeString(parseLocalTime(ts, tz));
}
function getTimeRangeOfMonth(year, month, tz = ENV_TIMEZONE) {
  return [
    new Date(buildISODateString({ yr: year, mo: month }, tz)).getTime(),
    new Date(buildISODateString({
      yr: month === 11 ? year + 1 : year,
      mo: month < 11 ? month + 1 : 0
    }, tz)).getTime() - 1
  ];
}
function makeTime(dt, tz = ENV_TIMEZONE) {
  return new Date(buildISODateString(
    {
      mo: 0,
      day: 1,
      hr: 0,
      min: 0,
      sec: 0,
      ms: 0,
      ...dt
    },
    tz
  )).getTime();
}
function makeTimeByString(dt, tz = ENV_TIMEZONE) {
  const d = new Date(dt);
  return new Date(buildISODateString(
    {
      yr: d.getFullYear(),
      mo: d.getMonth(),
      day: d.getDate(),
      hr: d.getHours(),
      min: d.getMinutes(),
      sec: d.getSeconds(),
      ms: d.getMilliseconds()
    },
    tz
  )).getTime();
}
function convertByTimeZone(ts, localTZ, targetTZ) {
  const d = new Date(ts - (tzToJS(localTZ) - (/* @__PURE__ */ new Date()).getTimezoneOffset()) * MS_PER_MINUTE);
  return makeTime(
    {
      yr: d.getFullYear(),
      mo: d.getMonth(),
      day: d.getDate(),
      hr: d.getHours(),
      min: d.getMinutes(),
      sec: d.getSeconds(),
      ms: d.getMilliseconds()
    },
    targetTZ
  );
}
function alignToSecond(ts) {
  return ts - ts % MS_PER_SECOND;
}
function alignToMinute(ts) {
  return ts - ts % MS_PER_MINUTE;
}
function alignToHour(ts) {
  return ts - ts % MS_PER_HOUR;
}
function alignToDay(ts, tz = ENV_TIMEZONE) {
  const lt = parseLocalTime(ts, tz);
  return makeTime({
    yr: lt.yr,
    mo: lt.mo,
    day: lt.day
  }, tz);
}
function alignToWeek(ts, tz = ENV_TIMEZONE, startAtMonday = false) {
  const lt = parseLocalTime(ts, tz);
  return makeTime({
    yr: lt.yr,
    mo: lt.mo,
    day: lt.day
  }, tz) - (lt.wd - (startAtMonday ? 1 : 0)) * MS_PER_DAY;
}
function alignToMonth(ts, tz = ENV_TIMEZONE) {
  const lt = parseLocalTime(ts, tz);
  return makeTime({
    yr: lt.yr,
    mo: lt.mo,
    day: 1
  }, tz);
}
function alignToYear(ts, tz = ENV_TIMEZONE) {
  const lt = parseLocalTime(ts, tz);
  return makeTime({ yr: lt.yr }, tz);
}
function addRegularMonth(ts, moQty, tz = ENV_TIMEZONE) {
  if (!Number.isSafeInteger(moQty)) {
    return ts;
  }
  const lt = parseLocalTime(ts, tz);
  const step = moQty / Math.abs(moQty);
  moQty = Math.abs(moQty);
  lt.yr += step * Math.floor(moQty / MONTH_PER_YEAR);
  let mo = lt.mo;
  mo += step * (moQty % MONTH_PER_YEAR);
  if (mo < 0) {
    lt.yr--;
    mo += MONTH_PER_YEAR;
  } else if (mo > 11) {
    lt.yr++;
    mo %= MONTH_PER_YEAR;
  }
  lt.mo = mo;
  const maxDay = getDaysInMonth(lt.yr, lt.mo);
  if (maxDay < lt.day) {
    lt.day = maxDay;
  }
  return makeTime(lt, tz);
}
function findNthWeekdayInMonth(nth, weekday, dt, tz = ENV_TIMEZONE) {
  if (nth === 0) {
    throw new RangeError("Invalid nth index number.");
  }
  if (nth < 0) {
    let t = makeTime({
      ...dt,
      day: getDaysInMonth(dt.yr, dt.mo)
    }, tz);
    const cwd = parseLocalTime(t, tz).wd;
    t -= MS_PER_DAY * (weekday <= cwd ? cwd - weekday : DAYS_PER_WEEK - weekday + cwd);
    return t - (-1 - nth) * MS_PER_WEEK;
  } else {
    let t = makeTime({
      ...dt,
      day: 1
    }, tz);
    const cwd = parseLocalTime(t, tz).wd;
    t += MS_PER_DAY * (weekday >= cwd ? weekday - cwd : DAYS_PER_WEEK - cwd + weekday);
    return t + (nth - 1) * MS_PER_WEEK;
  }
}
const REGEX_FORMAT = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,2}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,3}|Z{1}/g;
const defaultMonthNames = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12"
];
function format({
  time,
  pattern,
  monthNames = defaultMonthNames,
  longMonthNames = defaultMonthNames,
  shortMonthNames,
  timezone = ENV_TIMEZONE
}) {
  const localTime = parseLocalTime(time, timezone);
  const sm = shortMonthNames ?? monthNames.slice(0);
  return pattern.replace(
    REGEX_FORMAT,
    function(match) {
      switch (match) {
        case "YY":
          return String(localTime.yr % 100);
        case "YYYY":
          return String(localTime.yr);
        case "M":
          return String(localTime.mo + 1);
        case "MM":
          return pad(localTime.mo + 1, 2);
        case "MMM":
          return String(sm[localTime.mo]);
        case "MMMM":
          return String(longMonthNames[localTime.mo]);
        case "D":
          return String(localTime.day);
        case "DD":
          return pad(localTime.day, 2);
        case "d":
          return String(localTime.wd);
        case "dd":
          return pad(localTime.wd, 2);
        case "H":
          return String(localTime.hr);
        case "HH":
          return pad(localTime.hr, 2);
        case "h":
          return String(localTime.hr % 12);
        case "hh":
          return pad(localTime.hr % 12, 2);
        case "a":
          return localTime.hr < 12 ? "am" : "pm";
        case "A":
          return localTime.hr < 12 ? "AM" : "PM";
        case "m":
          return String(localTime.min);
        case "mm":
          return pad(localTime.min, 2);
        case "s":
          return String(localTime.sec);
        case "ss":
          return pad(localTime.sec, 2);
        case "sss":
          return pad(localTime.ms, 3);
        case "Z":
          return (localTime.timezone >= 0 ? "+" : "") + pad(Math.floor(localTime.timezone / 60)) + ":00";
        default:
          return match;
      }
    }
  );
}
function formatLocale({
  time,
  locale = "en",
  short = false,
  timezone = ENV_TIMEZONE,
  format: fm = "ymd"
}) {
  locale = String(locale).toLowerCase();
  const meta = Locales[locale];
  let pattern = "";
  if (fm === "ymd") {
    pattern = short ? meta.shortFormat : meta.longFormat;
  } else {
    pattern = short ? meta.ymShortFormat : meta.ymLongFormat;
  }
  const result = format({
    time,
    pattern,
    monthNames: meta.shortMonthNames,
    shortMonthNames: meta.shortMonthNames,
    longMonthNames: meta.longMonthNames,
    timezone
  });
  if (fm === "ym" && ["en", "en-gb"].includes(locale)) {
    return result.replace(/\./g, "");
  }
  return result;
}
export {
  DAYS_PER_WEEK,
  EGeneralTimeZones,
  EMonth,
  ENV_TIMEZONE,
  EWeekday,
  HOURS_PER_DAY,
  HOURS_PER_WEEK,
  MINUTES_PER_DAY,
  MINUTES_PER_HOUR,
  MINUTES_PER_WEEK,
  MONTH_PER_YEAR,
  MS_PER_DAY,
  MS_PER_HOUR,
  MS_PER_MINUTE,
  MS_PER_SECOND,
  MS_PER_WEEK,
  SECONDS_PER_DAY,
  SECONDS_PER_HOUR,
  SECONDS_PER_MINUTE,
  SECONDS_PER_WEEK,
  addRegularMonth,
  alignToDay,
  alignToHour,
  alignToMinute,
  alignToMonth,
  alignToSecond,
  alignToWeek,
  alignToYear,
  buildDateTimeString,
  buildISODateString,
  convertByTimeZone,
  findNthWeekdayInMonth,
  format,
  formatLocale,
  getDaysInMonth,
  getDaysInYear,
  getTimeRangeOfMonth,
  isLeapYear,
  makeTime,
  makeTimeByString,
  parseLocalTime,
  timeToDateTimeString,
  timeToISODateString,
  tzFromJS,
  tzToJS
};
//# sourceMappingURL=DateTime.js.map
